// extracted by mini-css-extract-plugin
export default {"container":"BeforeFirstGame_container__ZDT-2"};